import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { IconModule } from './../../../common/icon/icon.module';
import { FormFieldModule } from './../../../forms/form-field/form-field.module';
import { InputModule } from './../../../forms/input/input.module';
import { TimeZonePickerDropdownListComponent } from './time-zone-picker-dropdown-list.component';

@NgModule({
  declarations: [TimeZonePickerDropdownListComponent],
  exports: [TimeZonePickerDropdownListComponent],
  imports: [FormFieldModule, IconModule, InputModule, CommonModule, I18nModule],
})
export class TimeZonePickerDropdownListModule {}
